var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitorActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.092 6.114a3.145 3.145 0 010 3.772c-2.005 2.625-6.179 2.624-8.184 0a3.145 3.145 0 010-3.772c2.005-2.625 6.179-2.625 8.184 0z",
    fill: "#ADC9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9a1 1 0 100-2 1 1 0 000 2z",
    fill: "#105ED5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 8c-1.352 5.14-8.648 5.14-10 0 1.352-5.14 8.648-5.14 10 0zm-1.305 0c-1.2 3.473-6.19 3.473-7.39 0 1.2-3.473 6.19-3.473 7.39 0z",
    fill: "#105ED5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16c1.984 0 3.8-.722 5.198-1.918l1.958 1.958c-.429.72-.334 1.666.286 2.286l3.232 3.232c.732.732 1.92.732 2.652 0l.232-.232a1.875 1.875 0 000-2.652l-3.232-3.232a1.876 1.876 0 00-2.286-.286l-1.958-1.958A8 8 0 108 16zm0-1.25a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z",
    fill: "#105ED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorActive);
export default __webpack_public_path__ + "static/media/monitor-active.6abcca76d34f2bca1f36e0a8eaf25cea.svg";
export { ForwardRef as ReactComponent };